import { render, staticRenderFns } from "./RsaConfigurazionePostiLettoLettiEditComponent.vue?vue&type=template&id=279ffce6"
import script from "./RsaConfigurazionePostiLettoLettiEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazionePostiLettoLettiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports